<div class="container-fluid border-0 vh-100" >
    <div class="row p-0 border-0">
      <div class="bggradientBG d-none d-xl-block d-xxl-block border-0 p-0 col-xxl-2 col-xl-2 col-lg-12 col-md-12 col-sm-12 col-12 p-0 shadow overflow-y-scroll sticky-xl-top sticky-lg-top sticky-md-top sticky-sm-top">
        <app-docs-menu></app-docs-menu>
      </div>
      <div class=" border-0 col-xxl-10 col-xl-10 col-lg-12 col-md-12 col-sm-12 col-12 p-0 vh-100 overflow-y-scroll">
        <div class="col-12 sticky-top {{wid<1200?wid<992?'H17':'H15':'H10'}}  "  >
          <div class="">
            <div class="container-fluid bg-white col-12 shadow-sm border gap-0 gap-sm-0 d-flex flex-row flex-sm-row justify-content-start justify-content-sm-between w-100 m-0 p-0 ps-xl-4 ps-xxl-4 ps-lg-2 ps-md-2 ps-sm-1 ps-1 py-xl-3 py-xxl-3 py-lg-3 py-md-2 py-sm-2 py-2">
                <div class="d-flex col-6  flex-row align-items-center gap-1 gap-xl-3 gap-xxl-3 gap-lg-3 gap-md-2 gap-sm-2 justify-content-xl-start justify-content-xxl-start justify-content-lg-start justify-content-md-start justify-content-start justify-content-sm-between">
                    <img class="color59c8eb" src="/documents/assets/images/icons/tabler_world-pin.svg" alt="region">
                    <p class="align-middle m-0 d-none d-sm-block">Choose region</p>
                    <div class="dropdown dropdown-center px-0 px-sm-2 px-md-3">
                      <button class="px-3 py-0 h-25  shadow-none fs14 btn border bg-white d-flex align-middle align-items-center justify-content-between dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                       <span class="pe-1 pe-xl-5 pe-xxl-5 pe-lg-3 pe-md-3 pe-sm-2">{{region}}</span>
                      </button>
                      <ul class="dropdown-menu rounded-1 p-0 fs14 w-75">
                        <li><button class="dropdown-item rounded-top-1 border-bottom py-2" (click)="sendRegionName('Malaysia')">Malaysia</button></li>
                        <li><button class="dropdown-item rounded-bottom-1 py-2" (click)="sendRegionName('Indonesia')">Indonesia</button></li>
                      </ul>
                    </div>
                </div>
                <!-- demo checkout page -->
                <div class="mx-0 px-1 d-flex justify-content-end align-items-center justify-content-sm-end col-6 ">
                  <div class="">
                    <button class="btn bgcolor005baa dropdown-toggle democheckout mx-0 mx-sm-3 py-0 px-1 px-sm-3 d-flex justify-content-between align-items-center align-middle text-white fs12 fw-semibold" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                      <span class="d-none d-sm-block d-md-block text-white me-1">Demo </span>Checkout
                    </button>
                    <ul class="dropdown-menu dropdown-menu-end mt-2 col-10 col-sm-7 col-md-6 col-lg-5 border-0 rounded-1 shadow"  data-popper-placement="">
                      <li class="vstack gap-3 py-2">
                        <div class=" col-8 col-sm-8 col-md-5 ps-2 d-flex justify-content-center py-2">
                          <div class="border-start ps-3">
                            <p class="fw-bold fs14 mb-2 text-black">Bank Details</p>
                            <ul class="fs12 ps-0 list-unstyled">
                              <li class="ms-0"><span>Bank Type - Retail</span></li>
                              <li class="ms-0"><span>Bank Name - SBI Bank A</span></li>
                              <li class="ms-0"><span>User ID - 1234</span></li>
                              <li class="ms-0"><span>Password - 1234</span></li>
                            </ul>
                          </div>
                        </div>
                        <div class=" d-flex flex-nowrap justify-content-between px-3 px-sm-2 px-md-2 px-lg-3">
                              <div class=" col-8 ps-0 ps-sm-1">
                              <p class="fs10 lh-sm mb-0">Please proceed to review the payment transactions for testing by utilizing the Above details.</p>
                              </div>
                              <div class=" col-3 d-flex justify-content-center align-items-center ">
                                <a href="https://gomobi.io/demo/payment/ezyway/?data={%22ct%22:%22R0tfHIT31nOMeDc8mb2CVRsEBxq35bpSMK0asNV3U0P9AB0BaqO44VkXC2EgOVtzQ/Ir+vxeABBFXDYA4cNRlSJgK1QCqJBK6xY1xnJTkRZlQhZi6Fb49DMHG5TJ+NAJTRz6U90z31IOJLhAHJB7NTLYtG5ykmXItZAqlfw5Lks=%22,%22iv%22:%221518ec9c0ced2ff7b3a99c3608707c7f%22,%22s%22:%2209931e77596edf43%22}"
                                 target="_blank" class="btn bgcolor005baa text-white fs12 px-4 py-1 align-middle rounded-0">Test</a>
                              </div>
                        </div>
                              
                      </li>
                    </ul>
                  </div>
                </div>
            </div>
            <div  class="container-fluid p-0 m-0 d-block d-lg-block d-md-block d-sm-block d-xl-none d-xxl-none ">
                <app-docs-menu></app-docs-menu>
            </div>
        </div>
        </div>
        <div class="col-12  overflow-y-scroll {{wid<1200?wid<992?'H83':'H85':'H90'}} ">
          <div class="mt-0 p-1 px-3 px-xxl-4 px-xl-4 px-lg-4 px-md-3 px-sm-2 overflow-x-scroll " id="maincontent"> 
            <router-outlet></router-outlet>
          </div>
        </div>      
        <div> 
            <button
            id="scrollTop"
              class="scrolltop btn bggradientBG bordercolor51CB49 shadow-none p-0 pt-2 px-2 fs-5 border-3 rounded-5 position-absolute position-fixed bottom-0 end-0 translate-middle"
              (click)="scrollToTop()"
            >
            </button>
          </div>
      </div>
    </div>
  </div>
  
  





  
        <!--  -->
        <!-- <div class="mb-5 pb-4" id="maincontent">
        <p class="text-white visually-hidden">Lorem ipsum dolor sit, amet consectetur adipisicing elit.</p>          
        </div>       -->